// AB - Clinically-Proven Results PDP: Convert custom trigger on scroll + lock visibility once revealed
(function() {
  var hasScrolled = false;
  var locked = false;

  function triggerClinicalResults() {
    console.log("Trigger - Resultados Clínicamente Probados");
    window._conv_q = window._conv_q || [];
    window._conv_q.push({
      what: "triggerLocation",
      params: {
        locationId: "1004149744"
      }
    });
  }

  function lockVisible() {
    if (locked) return;
    locked = true;
    document.documentElement.classList.add('ab-clinical-results-active');
    if (observer) observer.disconnect();
  }

  function checkRevealed() {
    var el = document.querySelector('.ab-clinical-results-wrapper');
    if (!el) return;
    var display = window.getComputedStyle(el).display;
    if (display !== 'none') lockVisible();
  }

  var observer = new MutationObserver(checkRevealed);
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['style', 'class']
  });

  function onFirstScroll() {
    hasScrolled = true;
    triggerClinicalResults();
    window.removeEventListener('scroll', onFirstScroll);
    setTimeout(checkRevealed, 500);
    setTimeout(checkRevealed, 1500);
  }

  window.addEventListener('scroll', onFirstScroll, { passive: true });

  document.addEventListener('variant::changed', function() {
    if (!hasScrolled || locked) return;
    triggerClinicalResults();
  }, true);

  document.addEventListener('update::product_linking', function() {
    if (!hasScrolled) return;
    triggerClinicalResults();
    setTimeout(checkRevealed, 500);
    setTimeout(checkRevealed, 1500);
  });
})();

document.addEventListener('DOMContentLoaded', () => {
  function calcularPorciones(container) {
    const itemPorciones = document.querySelector('.item-porciones');
    const spanResultado = document.querySelector('.item-porciones > p > span');
    if (!itemPorciones || !spanResultado) return;

    const inputCantidad = container.querySelector('input[name="custom-quantity"]');
    if (!inputCantidad) return;

    const valorInput = Number(inputCantidad.value);
    const valorPorciones = Number(itemPorciones.getAttribute('value'));
    const resultado = valorInput * valorPorciones;
    spanResultado.textContent = resultado;
  }

  setTimeout(function() {
    document.body.addEventListener('click', (event) => {
      const quantityBreak = event.target.closest('.quantity-break');
      if (quantityBreak) {
        calcularPorciones(quantityBreak);
      }
    });
  }, 1000);
});

// convert-test:oct-q2-sticky-atc variant-b START
// AB - OCT Q2 Sticky ATC: en mobile el Sticky ATC solo aparece después de pasar el botón original de Add to Cart
// 1. En mobile optimize-product.css oculta el sticky desde el inicio hasta que se sepa la variante (html.ab-sticky-atc-ready).
// 2. Variante B: el CSS de Convert muestra .ab-sticky-atc-flag; este script la detecta y fija html.ab-sticky-atc-b por el
//    resto de la visita (Convert quita su CSS cuando cambia la URL: Skio agrega ?selling_plan=, cambio de sabor/tamaño).
//    Variante A: cuando Convert ya asignó la experiencia y la bandera no es visible (o a los 3s como respaldo) se libera.
// 3. Marca html.ab-sticky-atc-past cuando el botón original quedó arriba del viewport/header.
// 4. Dispara el trigger de Convert al entrar a la PDP y lo re-dispara en cada cambio de URL.
(function() {
  var PAST_CLASS = 'ab-sticky-atc-past';
  var VARIANT_CLASS = 'ab-sticky-atc-b';
  var READY_CLASS = 'ab-sticky-atc-ready';
  var EXPERIENCE_ID = '1004215015';
  var DECISION_TIMEOUT = 3000;
  var root = document.documentElement;
  var mq = window.matchMedia('(max-width: 834px)');
  var ticking = false;
  var flag = null;
  var locked = false;
  var ready = false;
  var assignedChecks = 0;
  var decisionInterval = null;
  var lastUrl = window.location.href;

  function triggerStickyAtc() {
    if (!mq.matches) return;
    console.log("Trigger - OCT Q2 Sticky ATC");
    window._conv_q = window._conv_q || [];
    window._conv_q.push({
      what: "triggerLocation",
      params: {
        locationId: "1004162406"
      }
    });
  }

  function retrigger() {
    triggerStickyAtc();
    setTimeout(triggerStickyAtc, 150);
    setTimeout(triggerStickyAtc, 600);
    setTimeout(triggerStickyAtc, 1500);
  }

  function setReady() {
    if (ready) return;
    ready = true;
    root.classList.add(READY_CLASS);
    if (decisionInterval) clearInterval(decisionInterval);
  }

  function isExperienceAssigned() {
    try {
      return !!(window.convert && window.convert.currentData && window.convert.currentData.experiences && window.convert.currentData.experiences[EXPERIENCE_ID]);
    } catch (e) {
      return false;
    }
  }

  // Variante B: se fija en cuanto Convert muestra la bandera (solo una vez por visita)
  // Variante A: Convert asignó la experiencia y la bandera sigue oculta en dos revisiones seguidas
  function checkVariant() {
    if (locked || !flag) return;
    if (!mq.matches) {
      setReady();
      return;
    }
    if (window.getComputedStyle(flag).display !== 'none') {
      locked = true;
      root.classList.add(VARIANT_CLASS);
      setReady();
      return;
    }
    if (!ready && isExperienceAssigned()) {
      assignedChecks++;
      if (assignedChecks >= 2) setReady();
    }
  }

  // Se consulta el botón en cada actualización porque el product linking lo reemplaza al cambiar variante/sabor
  function update() {
    ticking = false;
    if (!mq.matches) {
      root.classList.remove(PAST_CLASS);
      return;
    }
    var btn = document.querySelector('main-product .product-form__submit');
    if (!btn) return;
    var rect = btn.getBoundingClientRect();
    if (rect.width === 0 && rect.height === 0) return;
    var header = document.querySelector('.header-main-wrapper');
    var headerBottom = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
    root.classList.toggle(PAST_CLASS, rect.bottom <= headerBottom);
  }

  function requestUpdate() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  }

  function onUrlChange() {
    if (window.location.href === lastUrl) return;
    lastUrl = window.location.href;
    checkVariant();
    retrigger();
  }

  // Detecta cambios de URL hechos con history (Skio, variant picker, product linking)
  function watchHistory() {
    ['pushState', 'replaceState'].forEach(function(method) {
      var original = window.history[method];
      if (typeof original !== 'function') return;
      window.history[method] = function() {
        var result = original.apply(this, arguments);
        onUrlChange();
        return result;
      };
    });
    window.addEventListener('popstate', onUrlChange);
  }

  function init() {
    flag = document.createElement('div');
    flag.className = 'ab-sticky-atc-flag';
    flag.setAttribute('aria-hidden', 'true');
    document.body.appendChild(flag);

    update();
    checkVariant();
    if (!locked) {
      // Convert inyecta su <style> en el <head>; se revisa cada vez que se agrega uno (aunque ya se haya liberado el sticky)
      new MutationObserver(checkVariant).observe(document.head, { childList: true });
      decisionInterval = setInterval(checkVariant, 100);
      // Respaldo: si Convert no responde (bloqueado, fuera de la prueba) se libera el sticky
      setTimeout(setReady, DECISION_TIMEOUT);
    }

    // Trigger al entrar a la PDP
    triggerStickyAtc();
    watchHistory();

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    if (mq.addEventListener) mq.addEventListener('change', requestUpdate);
    else if (mq.addListener) mq.addListener(requestUpdate);

    function onOptionChanged() {
      requestUpdate();
      setTimeout(requestUpdate, 300);
    }
    document.addEventListener('variant::changed', onOptionChanged, true);
    document.addEventListener('update::product_linking', onOptionChanged);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
// convert-test:oct-q2-sticky-atc variant-b END
